export const tr = {
    moscow: 'Moskova',
    'phone-extension': 'dahili: {phone}',
    regions: 'Bölgeler'
};
